import { DELETE_WEAVE, EDIT_WEAVE, ADD_WEAVE, GET_WEAVE } from "../../Types";
const initialState = {
  weave: [],
};

function weave(state = initialState, action) {
  switch (action.type) {
    case ADD_WEAVE: {
      return {
        ...state,
        weave: [...state.weave, action.payload],
      };
    }
    case GET_WEAVE: {
        const allWeave = action.payload;
        return { ...state, weave: allWeave };
     
    }
    case EDIT_WEAVE: {
        let updateWeave = state.weave.map((item) =>
          item.weave_id === action.payload.weave_id
            ? action.payload
            : item
        );
        return {
          ...state,
          weave: updateWeave,
        };
     
    }
    case DELETE_WEAVE: {
      const after_delete_weave = state.weave.filter(
        (weave) =>
          weave.weave_id !== action.payload.weave_id
      );
      console.log(after_delete_weave);
      return { ...state, weave: after_delete_weave };
     
    }
    default:
      return state;
  }
}

export default weave;
